<template>
    <div class="pantalla-menu">
        <div class="container-mob w-100">

            <buscador-component></buscador-component>
        </div>
        <div class="mb-3" v-if="this.show_banner">

            <carousel :items="1" :nav="false" :autoHeight="true">
                <a v-for="banner in this.banners" :href="banner.url" class="" target="_blank" :id="'banner_'+banner.id" @click="bannerclick(banner)">
                    <img :src="'/storage/'+banner.imagen" class="img-fluid slider-image mx-auto mb-4">
                </a>
            </carousel>
        </div>


        <div class="secciones">

            <div class="text-end" v-if="show_volver">
                <span @click="goBack()" class="color-red pe-3">
                    <i class="fas fa-chevron-left"></i>
                </span>
            </div>


            <div v-if="this.view_type ==='categorias'">
                <div v-if="!selected_category && !series" class="container px-4">
                    <div v-for="(category, key) in categories">
                        <div v-if="!category.parent_id">
                            <h2>{{ category.name }}</h2>
                            <div class="row">
                                <div v-for="(subcategory, key) in categories" class="col-6 mx-auto">
                                    <div class="categoria-interior text-center" v-if=" subcategory.parent_id === category.id" @click="setSelectedCategory(subcategory)">
                                        <img :src="'/storage/'+subcategory.image" class="imagen-producto">
                                        <p class="color-red mt-3 mb-0">{{ subcategory.name }}</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="!series">
                        <div class="container">
                            <h3>{{ this.category_title }}</h3>
                        </div>
                        <div class="series-contenedor">
                            <div class="row series-scroll">
                                <div class="col-5" v-for="(categoria, key) in categories" v-if=" categoria.parent_id === selected_category.id" @click="setSelectedCategory(categoria)">
                                    <div class="series  text-center">
                                        <img :src="'/storage/'+categoria.image" class="imagen-producto">
                                        <p class="color-red mt-3 mb-0">{{ categoria.name }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="container">
                            <h3>{{ this.category_title }}</h3>
                        </div>
                        <div class="series-contenedor">
                            <div class="row series-scroll">
                                <div v-for="(serie, key) in series" class="col-5">
                                    <div class="series text-center" @click="getProducts(serie)">
                                        <img :src="'/storage/'+serie.imagen" class="imagen-producto">
                                        <p class="color-red mt-3 mb-0">{{ serie.nombre }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <recientes-component></recientes-component>
                </div>
            </div>

            <div v-else-if="this.view_type === 'productos'">
                <div class="container">
                    <h3>{{ this.category_title }}</h3>
                </div>
                <div class="series-contenedor">
                    <div class="row series-scroll">
                        <div v-for="(producto, key) in products" class="col-5 enlace-producto">
                            <router-link :to="{ name: 'producto', params: { slug: producto.slug } }" class="series text-center">
                                <img :src="'/storage/'+producto.imagenes[0]" class="imagen-producto">
                                <p class="color-red mt-3 mb-0">{{ producto.nombre }}</p>
                            </router-link>
                        </div>
                    </div>
                </div>
                <recientes-component></recientes-component>
            </div>


            <div v-else-if="this.view_type === 'potencias'" class="elige-potencia mt-4">
                <h2 class="mb-4 ms-4">Elige la potencia</h2>
                <div v-for="(potencia, key) in potencias" class="enlace-potencia">
                    <router-link :to="{ name: 'producto', params: { slug: potencia.producto_slug } }">
                        <div class=" d-flex justify-content-between">
                            <div>
                                <span class="ms-3">{{ potencia.valor }} <small>kW</small></span>
                                <small>{{ potencia.subtext }}</small>
                            </div>
                            <div>
                                <i class="fas fa-chevron-right"></i>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>

            <menu-component></menu-component>
        </div>

    </div>


</template>

<script>

export default {
    data() {
        return {
            categories: null,
            banners: [],
            selected_category: null,
            series: null,
            errors: null,
            category_title: '',
            view_type: 'categorias',
            products: null,
            potencias: null,
            show_banner: true,
            show_volver: false,
            anterior: ''
        };
    },
    methods: {
        setSelectedCategory(subcategory) {
            let has_series = subcategory.series.length > 0;

            if (subcategory.productos) {
                this.getProducts(subcategory.series[0], 'inicio');
            }

            if (has_series) {
                this.series = subcategory.series;
            } else {
                this.selected_category = subcategory;
            }

            this.anterior = 'categorias';
            this.category_title = subcategory.full_name;
            this.show_banner = false;
            this.show_volver = true;
        },
        getProducts(serie, inicio = null) {
            let view_type;
            if (serie.filtro_potencia) {
                view_type = 'potencias';
            } else {
                view_type = 'productos';
            }
            this.$store
            .dispatch("getProducts", {serie_id: serie.id, view_type: view_type})
            .then(response => {
                this.view_type = view_type;
                if (serie.filtro_potencia) {
                    this.potencias = response.data;
                } else {
                    this.products = response.data;
                }
                this.anterior = inicio !== null ? inicio : 'productos';
            })
            .catch(error => {
                this.errors = error.response.data;
            });
        },
        goBack(action) {
            if (this.anterior === "categorias") {
                if (this.series !== null) {
                    this.anterior = 'categorias';
                    if (this.selected_category === null) {
                        this.show_banner = true;
                        this.show_volver = false;
                    }
                } else {
                    this.selected_category = null;
                    this.show_banner = true;
                    this.anterior = '';
                    this.show_volver = false;
                }
                this.series = null;
            } else if (this.anterior === "series") {
                this.series = null;
                this.anterior = 'categorias';
            } else if (this.anterior === "productos") {
                if (this.view_type === "potencias") {
                    this.view_type = 'categorias';
                } else {
                    this.anterior = this.selected_category === null ? 'categorias' : 'series';
                    if (this.selected_category !== null) {
                        this.series = null;
                    }
                    this.view_type = 'categorias';
                }
            } else if (this.anterior === "inicio") {
                window.location.href = "/";
            }
        },
        bannerclick(banner){
            gtag('event', 'click_banner', {'event_category': 'Banner_Home', 'banner_nombre': banner.nombre});
        }
    },
    mounted: function () {
        var that = this;
        this.$store
        .dispatch("getCategories")
        .then(response => {
            this.categories = response.data;

            let urlParams = new URLSearchParams(window.location.search);
            let s = parseInt(urlParams.get('s'));
            if (s) {
                response.data.forEach(function (categoria) {
                    if (categoria.id === s) {
                        that.setSelectedCategory(categoria);
                    }
                });
            }

        })
        .catch(error => {
            console.log(error)
        });

        this.$store
        .dispatch("getBanners")
        .then(response => {
            this.banners = response.data;
        })
        .catch(error => {
            this.errors = error.response.data;
        });
    }
};
</script>
